import React from 'react';
import dynamic from 'next/dynamic';
import withApollo from '../lib/apollo';
import loadingComponent from '../lib/loading';

const SchoolProfileCourses = dynamic(() => import(
  '../components/Company/SchoolProfileCourses'
), {
  ssr: true,
  loading: loadingComponent,
});

const CompanyLayout = dynamic(() => import('../components/Company/Layout'), {
  ssr: true,
  loading: loadingComponent,
});

const SchoolProfileCoursesPage = () => (<SchoolProfileCourses />);

SchoolProfileCoursesPage.getLayout = (page) => (
  <CompanyLayout layoutMaxWidth="1440px">
    {page}
  </CompanyLayout>
);

export default withApollo(SchoolProfileCoursesPage);
